import React from 'react';
// No Helmet or useEffect needed!

// We have updated this list to include all your specific keywords
const allServices = [
  { 
    img: "https://images.pexels.com/photos/4348401/pexels-photo-4348401.jpeg", 
    title: "Technical Design & Spec-Sheets", 
    desc: "As technical apparel designers, we build your vision. This includes detailed techpacks, spec-sheets, and flat sketches." 
  },
  { 
    img: "https://images.pexels.com/photos/4974914/pexels-photo-4974914.jpeg", 
    title: "Digital Design (Illustrator, Clo3D)", 
    desc: "Expert digital creation. We are proficient in Adobe Illustrator, Clo3D, and CorelDRAW for all your design needs." 
  },
  { 
    img: "https://images.pexels.com/photos/34563855/pexels-photo-34563855.jpeg", 
    title: "Construction Callouts & Details", 
    desc: "Precision is key. We provide clear construction specifications and callouts to ensure your sample is perfect." 
  },
  { 
    img: "https://images.pexels.com/photos/3807755/pexels-photo-3807755.jpeg", 
    title: "Graphic Design & Vector Files", 
    desc: "We design custom logos and graphics for your brand, providing high-quality, production-ready vector files." 
  },
  { 
    img: "https://images.pexels.com/photos/4614204/pexels-photo-4614204.jpeg", 
    title: "Sourcing & Low-MOQ Manufacturing", 
    desc: "We connect you with our network of global partners for low-MOQ manufacturing and high-quality materials sourcing." 
  },
  { 
    img: "https://images.pexels.com/photos/4614204/pexels-photo-4614204.jpeg", 
    title: "Sample Development & QC", 
    desc: "Producing accurate samples for your approval and providing quality control before you commit to bulk production." 
  },
];


function ServicesPage() {

  return (
    // We add padding-top (pt-32) to make space for the fixed navbar
    <div className="min-h-screen bg-gray-100 py-16 pt-32">
      
      {/* --- THIS IS THE NEW, KEYWORD-PACKED SEO --- */}
      <title>Technical Apparel Designer & Flat Sketch Services - Techpack Creators</title>
      <meta 
        name="description" 
        content="Technical apparel designers using Illustrator, Clo3D, & CorelDRAW. We create flat sketches, spec-sheets, vector files, logos, & construction callouts." 
      />
      {/* --- END OF NEW SEO --- */}

      <div className="container mx-auto px-6 text-center">
        
        <h1 className="text-5xl font-bold mb-16 font-montserrat">
          Our Services
        </h1>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 max-w-7xl w-full mx-auto">
          {allServices.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg overflow-hidden transition-transform duration-300 hover:scale-105 hover:shadow-2xl text-left"
            >
              <img src={service.img} alt={service.title} className="w-full h-48 object-cover" />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-2 font-montserrat text-gray-800">{service.title}</h3>
                <p className="text-gray-700 font-montserrat">{service.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default ServicesPage;